export type ValuatorData = {
  discountRatePercentage: number; // discountRate
  fairValue: number; // fairValue
  futureSharesOutstanding: number; // futureSharesOutstanding
  priceEarningsMultiple: number; // futurePePercentageChange
  profitMarginPercentage: number; // profitMarginPercentageChange
  revenuePercentage: number; // revenuePercentageChange
  timePeriod: number; // timeframe
  exchangeRate: number; // reporting currency to listing currency exchange rate
  sharesOutstandingGrowthRate: number;
};

export type NarrativeForm = ValuatorData & {
  title: string;
  content: {
    text: string;
    html: string;
  };
  coreContent: {
    text: string;
    html: string;
  };
  userHoldsPosition: boolean | null;
};

export const NARRATIVE_USER_POSITION = {
  HOLDS: 'holds',
} as const;

export const FAIR_VALUE_PRECISION = 6;
export const VALUATOR_RATE_PRECISION = 2;
